import React from 'react';
import { Card } from 'antd';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
//import './TicketCreationByDays.css';

// Sample Data
const sampleCreationByDays = [
  { day: 'Monday', count: 10 },
  { day: 'Tuesday', count: 14 },
  { day: 'Wednesday', count: 8 },
  { day: 'Thursday', count: 20 },
  { day: 'Friday', count: 15 },
  { day: 'Saturday', count: 5 },
  { day: 'Sunday', count: 12 },
];

const CustomYAxis = ({ tickSize = 5, stroke = "#8884d8", ...props }) => (
  <YAxis tickSize={tickSize} stroke={stroke} {...props} />
);
const TicketCreationByDays: React.FC = () => {
  return (
  <Card title="Tickets Creation by Days of the Week" className="chart-full">
              <ResponsiveContainer width="100%" height={250}>
                <BarChart data={sampleCreationByDays}>
                  <XAxis dataKey="day" />
                  <CustomYAxis />
                  <Tooltip />
                  <Bar dataKey="count" fill="#8884d8" />
                </BarChart>
              </ResponsiveContainer>
            </Card>
);};

export default TicketCreationByDays;
